import React, { useState, useCallback } from "react";
import ProductRow from "./ProductRow";
import { useProductsStore } from "../../stores/productsStore";
import { useProductsSelectionStore } from "../../stores/productsSelectionStore";
import { ImageModal, PermissionWrapper } from "components";
import { useAuth } from "hooks/useAuth";

// Конфігурація заголовків таблиці
const headers = [
  { label: "Артикул", field: "article" },
  { label: "Фото", field: "img_url" },
  { label: "Назва", field: "name" },
  { label: "Ціна", field: "price" },
  { label: "Наявність", field: "available" },
  {
    label: "Статус",
    field: "update_status",
    requiredPermission: "products:edit",
    className: "status-column",
  },
];

// Компонент для відображення таблиці сторінки "Товари постачальників"
const ProductsTable = React.memo(() => {
  // Отримуємо дані та дії безпосередньо зі стору
  const products = useProductsStore((state) => state.products);
  const sort_by = useProductsStore((state) => state.filters.sort_by);
  const sort_asc = useProductsStore((state) => state.filters.sort_asc);
  const setSort = useProductsStore((state) => state.setSort);
  const optimisticUpdateStatus = useProductsStore(
    (state) => state.optimisticUpdateStatus,
  );

  // Отримуємо стан режиму вибору
  const isSelectionModeActive = useProductsSelectionStore(
    (state) => state.isSelectionModeActive,
  );

  // Рахуємо лише ті колонки, які реально видно користувачу
  const { isAllowed } = useAuth();
  const visibleHeadersCount =
    headers.filter(
      ({ requiredPermission }) => !requiredPermission || isAllowed(requiredPermission),
    ).length + (isSelectionModeActive ? 1 : 0);

  const [selectedImage, setSelectedImage] = useState(null);
  // Обробник кліку по мініатюрі зображення
  const handleImageClick = useCallback((imgUrl) => {
    if (!imgUrl) return;
    setSelectedImage(imgUrl);
  }, []);
  // Закриття модального вікна зображення
  const closeImageModal = useCallback(() => {
    setSelectedImage(null);
  }, []);

  return (
    <>
      <table id="product-table">
        <thead>
          <tr>
            {isSelectionModeActive && <th className="selection-column"></th>}
            {headers.map(({ label, field, requiredPermission, className }) => (
              <PermissionWrapper key={label} requiredPermission={requiredPermission}>
                <th
                  className={`${field ? "clickable" : ""} ${className || ""}`.trim()}
                  onClick={field ? () => setSort(field) : undefined}
                >
                  {label}
                  {field && (
                    <span className="sort-icon">
                      {field === sort_by && (sort_asc ? " ▲" : " ▼")}
                    </span>
                  )}
                </th>
              </PermissionWrapper>
            ))}
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan={visibleHeadersCount} className="empty-row">
                Немає даних товарів постачальників
              </td>
            </tr>
          ) : (
            products.map((product) => (
              <ProductRow
                key={product.article}
                product={product}
                onStatusUpdate={optimisticUpdateStatus}
                onImageClick={handleImageClick}
              />
            ))
          )}
        </tbody>
      </table>
      <ImageModal
        isOpen={!!selectedImage}
        src={selectedImage}
        alt="Enlarged"
        onClose={closeImageModal}
      />
    </>
  );
});

export default ProductsTable;
